import AuthService from '../auth'
import { createAxiosClient } from '../core'

const client = createAxiosClient('/export')

export default AuthService.register(client)
